import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import KitA from './kitA';
import KitB from './kitB';
import KitC from './kitC';
import TabListA from './tabListA';
import TabListB from './tabListB';
import TabListC from './tabListC';
import Modals from './modals';
import AniComp from './aniComp';
import { useGlobal } from '@/utils/useGlobal';
import ScrollMagicFn from '@/utils/ScrollMagic';

export const READY_HOME_TAB_SITES = [];

export default function Product({}) {
    const { useLang } = useGlobal();
    const { locale = 'us' } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [activeType, setActiveType] = useState('rv');
    const [activeModal, setActiveModal] = useState('');

    // 这一段必须要先于子组件触发
    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
        window.AniContainer = new ScrollMagic.Controller();
    }

    const switchTabFn = (aType: string) => {
        setActiveType(aType);
    };

    useEffect(() => {
        const htmlEl = document.querySelector('html') as HTMLElement;
        if (htmlEl) {
            if (activeModal && !htmlEl.classList.contains('ef-has-modal-full-viewport')) {
                htmlEl.classList.add('ef-has-modal-full-viewport');
            }
            if (!activeModal && htmlEl.classList.contains('ef-has-modal-full-viewport')) {
                htmlEl.classList.remove('ef-has-modal-full-viewport');
            }
        }
    }, [activeModal]);

    useEffect(() => {
        return () => {
            // 先移除scene 再移除controller
            // scene 在子模块内移除
            // 因卸载阶段父组件先触发，所以需setTimeout滞后
            setTimeout(() => {
                AniContainer?.destroy(true);
            }, 30);
        };
    }, []);

    return (
        <div className={`${css.kitProduct} kitProduct`}>
            <KitA />
            <KitB />
            <KitC />
            {locale !== 'au' && (
                <div className="kit-tab-head">
                    <div
                        className={`kit-tab-head-item ${activeType == 'rv' ? ' active' : ''}`}
                        onClick={() => {
                            switchTabFn('rv');
                        }}
                    >
                        <span className="kit-tab-head-item-ms tab-left">{t('presale.product.kit_tab_item_1')}</span>
                    </div>
                    <div
                        className={`kit-tab-head-item ${activeType == 'grid' ? ' active' : ''}`}
                        onClick={() => {
                            switchTabFn('grid');
                        }}
                    >
                        <span className="kit-tab-head-item-ms tab-mid">{t('presale.product.kit_tab_item_2')}</span>
                    </div>
                    {READY_HOME_TAB_SITES.includes(locale) && (
                        <div
                            className={`kit-tab-head-item ${activeType == 'home' ? ' active' : ''}`}
                            onClick={() => {
                                switchTabFn('home');
                            }}
                        >
                            <span className="kit-tab-head-item-ms tab-right">{t('presale.product.kit_tab_item_3')}</span>
                        </div>
                    )}
                </div>
            )}
            <div className="kit-tab-cont">
                <div className={`kit-tab-cont-item ${activeType == 'rv' ? ' active' : ''}`}>
                    <TabListA callBack={setActiveModal} tab={activeType} />
                </div>
                <div className={`kit-tab-cont-item ${activeType == 'grid' ? ' active' : ''}`}>
                    <TabListB callBack={setActiveModal} tab={activeType} />
                </div>
                {READY_HOME_TAB_SITES.includes(locale) && (
                    <div className={`kit-tab-cont-item ${activeType == 'home' ? ' active' : ''}`}>
                        <TabListC callBack={setActiveModal} tab={activeType} />
                    </div>
                )}
            </div>
            {activeModal && (
                <div className={`modal modal-ecoflow-power-kits ${activeModal ? 'activeModal' : ''}`}>
                    <Modals active={activeModal} callBack={setActiveModal} />
                </div>
            )}
            <AniComp callBack={setActiveModal} activeType={activeType} key={activeType} />
        </div>
    );
}
